import { useSelector } from 'react-redux';

export default function useAuth() {
    const state = useSelector((st) => st);
    const { user } = state.auth;
    const isLoggedIn = Boolean(user?.id);
    const isPastor = Boolean(user?.status?.pastor);
    const isChurchMember = Boolean(user?.church?.id);
    const isExternalUser = isLoggedIn && !isChurchMember;

    return {
        user,
        isLoggedIn,
        isPastor,
        isChurchMember,
        isExternalUser,
    };
}
